'use client';

import React from 'react';
import ErrorPage from './ErrorPage';

interface ErrorPageModuleProps {
  statusCode: number;
}

const ErrorPageModule: React.FC<ErrorPageModuleProps> = ({ statusCode }) => {
  return <ErrorPage statusCode={statusCode} />;
};

export default ErrorPageModule;
